import {LicensesEnum} from '../../monitoring/licenses.enum';
import {SublicensesEnum} from '../../monitoring/sublicenses.enum';
import { MediaTypeEnum } from '../../../Common/Basic/enums/media-type.enum';
export interface LicenseSummary {
    licenseId: LicensesEnum;
    provider?: string;
}

export const LICENSE_ID_MAPPER: Record<LicensesEnum, string> = {
    [LicensesEnum.CRITICAL_MENTION]: 'AMT.broadcast.criticalMention',
    [LicensesEnum.NLA_PRINT]: 'AMT.contentProviders.nla_print',
    [LicensesEnum.NLA_ECLIPS]: 'AMT.contentProviders.nla_online',
    [LicensesEnum.POST_MEDIA]: 'AMT.contentProviders.post_media',
    [LicensesEnum.PRECISE]: 'AMT.contentProviders.kantar',
    [LicensesEnum.ACQUIRE]: 'AMT.contentProviders.acquire',
    [LicensesEnum.MOREOVER]: 'AMT.contentProviders.online',
    [LicensesEnum.CLA_ONLINE]: 'AMT.contentProviders.cla_online',
    [LicensesEnum.CLA_PRINT]: 'AMT.contentProviders.cla_print',
    [LicensesEnum.IPCB]: 'AMT.contentProviders.ipcb',
    [LicensesEnum.LEXISNEXIS]: 'AMT.contentProviders.lexisNexis',
    [LicensesEnum.MELTWATER]: 'AMT.contentProviders.meltwater',
    [LicensesEnum.BURELLES_LUCE]: 'AMT.contentProviders.burrelles',
    [LicensesEnum.XCAGO]: 'AMT.contentProviders.pmg',
    [LicensesEnum.SMART_PROXY]: 'AMT.contentProviders.smart_proxy',
    [LicensesEnum.FINANCIAL_TIMES]: 'AMT.contentProviders.finacial_times',
    [LicensesEnum.REFMEDIA]: 'AMT.contentProviders.refMedia',

    [LicensesEnum.FINANCIAL_PODCASTS]: 'AMT.contentProviders.podcasts.financial',
    [LicensesEnum.FACTIVA]: 'AMT.contentProviders.factiva',
    [LicensesEnum.CEDROM]: 'AMT.contentProviders.Cedrom',
    [LicensesEnum.MANUALLY_CREATED]: 'AMT.contentProviders.manually_Created',
    [LicensesEnum.NEXIS]: 'AMT.contentProviders.nexis',
    [LicensesEnum.SNAPSHOT]: 'AMT.contentProviders.cs_supplemental.snapshot',
    [LicensesEnum.CS_IMPORT]: 'AMT.contentProviders.cs_supplemental.import',

    [LicensesEnum.TWITTER]: `MediaType.${MediaTypeEnum.TWITTER}`,
    [LicensesEnum.FACEBOOK]: `MediaType.${MediaTypeEnum.FACEBOOK}`,
    [LicensesEnum.INSTAGRAM]: `MediaType.${MediaTypeEnum.INSTAGRAM}`,
    [LicensesEnum.YOUTUBE]: `MediaType.${MediaTypeEnum.YOUTUBE}`,
    [LicensesEnum.REDDIT]: `MediaType.${MediaTypeEnum.REDDIT}`,
    [LicensesEnum.PODCASTS]: `MediaType.${MediaTypeEnum.PODCAST}`,
    [LicensesEnum.LINKEDIN]: `MediaType.${MediaTypeEnum.LINKEDIN}`,
    [LicensesEnum.BLUESKY]: `MediaType.${MediaTypeEnum.BLUESKY}`,
    [LicensesEnum.TIKTOK]: `MediaType.${MediaTypeEnum.TIKTOK}`,
    [LicensesEnum.MAGAZINE]: `MediaType.${MediaTypeEnum.MAGAZINE}`,

    [LicensesEnum.TVEYES]: 'AMT.broadcast.tvEyes',
    [LicensesEnum.NEWSDESK]: 'AMT.mentionImport.newsdesk',
    [LicensesEnum.CSV]: 'AMT.mentionImport.csv',
};

export class LicenseSummaryModel {
    licenseName: string = '';
    mercuryId: string = '';
    additionalInfo: string = '';

    constructor(licenseSummary: LicenseSummary, mercuryId?: string) {
        const licenseId = licenseSummary.licenseId;

        if (licenseId != null) {
            this.licenseName = LICENSE_ID_MAPPER[licenseId] ?? '';
        }

        if (licenseId === LicensesEnum.MOREOVER && licenseSummary.provider) {
            this.additionalInfo = ` (${licenseSummary.provider})`;
        }

        if (mercuryId) {
            this.mercuryId = mercuryId;
        }
    }
}
